import { theme } from '../../../styles/theme';

// Intentionally renders a custom SVG with all the colors from theme variables.
const EmptyDashboardVector = () => (
  <svg
    width="305"
    height="226"
    viewBox="0 0 305 226"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M115.311 144.981L96.8935 126.567C102.232 120.158 104.894 111.938 104.325 103.616C103.757 95.2947 100.003 87.5126 93.8431 81.8888C87.6834 76.2649 79.5927 73.2323 71.254 73.4219C62.9154 73.6114 54.9708 77.0084 49.0729 82.9062C43.1751 88.8041 39.778 96.7487 39.5885 105.087C39.399 113.426 42.4316 121.517 48.0554 127.676C53.6793 133.836 61.4613 137.591 69.7828 138.159C78.1042 138.727 86.3244 136.065 92.7332 130.727L111.147 149.144C111.421 149.418 111.745 149.635 112.102 149.783C112.46 149.931 112.843 150.007 113.229 150.007C113.616 150.007 113.999 149.931 114.356 149.783C114.713 149.635 115.038 149.418 115.311 149.144C115.585 148.871 115.801 148.546 115.949 148.189C116.097 147.832 116.174 147.449 116.174 147.062C116.174 146.676 116.097 146.293 115.949 145.936C115.801 145.579 115.585 145.254 115.311 144.981ZM45.5469 105.865C45.5469 100.626 47.1002 95.506 50.0103 91.1506C52.9204 86.7953 57.0567 83.4007 61.8961 81.3962C66.7355 79.3917 72.0606 78.8672 77.1981 79.8891C82.3356 80.911 87.0546 83.4334 90.7585 87.1373C94.4624 90.8412 96.9848 95.5603 98.0067 100.698C99.0286 105.835 98.5042 111.16 96.4996 116C94.4951 120.839 91.1005 124.975 86.7452 127.886C82.3898 130.796 77.2694 132.349 72.0312 132.349C65.0095 132.341 58.2777 129.548 53.3126 124.583C48.3475 119.618 45.5547 112.886 45.5469 105.865Z"
      fill={theme.colors.mainBlue}
    />
    <path
      d="M61.6667 118L61.6667 108"
      stroke={theme.colors.secondary900}
      strokeWidth="5"
      strokeLinecap="round"
    />
    <path
      d="M71.6667 118L71.6667 92.1667"
      stroke={theme.colors.secondary900}
      strokeWidth="5"
      strokeLinecap="round"
    />
    <path
      d="M81.6667 118L81.6667 98.8333"
      stroke={theme.colors.secondary900}
      strokeWidth="5"
      strokeLinecap="round"
    />
    <rect
      x="1"
      y="55.6667"
      width="141.333"
      height="105.5"
      rx="15.6667"
      stroke={theme.colors.border}
      strokeWidth="2"
    />
    <rect
      x="162.667"
      y="1.5"
      width="141.333"
      height="105.5"
      rx="15.6667"
      stroke={theme.colors.border}
      strokeWidth="2"
    />
    <rect
      x="162.667"
      y="125.667"
      width="118"
      height="98.8333"
      rx="15.6667"
      stroke={theme.colors.border}
      strokeWidth="2"
    />
    <rect
      x="221.667"
      y="24.6667"
      width="40"
      height="13.3333"
      fill={theme.colors.blue500}
    />
    <rect
      x="221.667"
      y="48"
      width="57.5"
      height="13.3333"
      fill={theme.colors.blue500}
    />
    <rect
      x="209.167"
      y="71.3333"
      width="39.1667"
      height="13.3333"
      fill={theme.colors.blue500}
    />
    <rect
      x="184.167"
      y="24.6667"
      width="40.8333"
      height="13.3333"
      fill={theme.colors.mainBlue}
    />
    <rect
      x="184.167"
      y="48"
      width="57.5"
      height="13.3333"
      fill={theme.colors.mainBlue}
    />
    <rect
      x="184.167"
      y="71.3333"
      width="47.5"
      height="13.3333"
      fill={theme.colors.mainBlue}
    />
    <path
      d="M220.417 148.833C215.551 148.833 210.748 149.94 206.373 152.07C201.998 154.2 198.165 157.297 195.163 161.128C192.162 164.958 190.071 169.42 189.049 174.178C188.027 178.935 188.1 183.863 189.264 188.588C190.428 193.313 192.651 197.711 195.765 201.45C198.879 205.189 202.803 208.171 207.24 210.169C211.677 212.168 216.51 213.131 221.374 212.986C226.238 212.841 231.005 211.591 235.314 209.331L220.417 180.917V148.833Z"
      fill={theme.colors.mainBlue}
    />
    <path
      d="M221.667 137.167C227.872 137.167 234.002 138.525 239.626 141.148C245.25 143.77 250.231 147.591 254.22 152.344L221.667 179.667V137.167Z"
      fill={theme.colors.secondary900}
    />
    <path
      d="M236.527 208.791C240.644 206.688 244.235 203.686 247.035 200.008C249.834 196.33 251.771 192.069 252.702 187.541C253.633 183.013 253.533 178.334 252.411 173.85C251.289 169.365 248.787 164.889 245.833 161.333L222.083 181.333L236.527 208.791Z"
      fill={theme.colors.blue900}
    />
  </svg>
);

export default EmptyDashboardVector;
